import { createSlice } from '@reduxjs/toolkit';
import { _setSelectedStudentTrackers } from './ssaStudentTrackersAction';

const initialState = {
  selectedStudentTrackers: [],
};

export const ssaStudentTrackersSlice = createSlice({
  name: 'delta/SSAStudentTracker',
  initialState: initialState,
  reducers: {
    resetSelectedStudentTrackers: () => initialState,
    setSelectedStudentTrackers: _setSelectedStudentTrackers,
  },
});

export const { setSelectedStudentTrackers, resetSelectedStudentTrackers } =
  ssaStudentTrackersSlice.actions;

export default ssaStudentTrackersSlice.reducer;
